
export const pricing = {
  'request.pricing': 'Richiedi prezzi',
  'view.pricing': 'Visualizza prezzi',
  'product.pricing': 'Prezzi dei prodotti',
};
